import { useQuery } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { useSession } from '@sdk/session/SessionContext';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';

import { getSeenByQueryKey } from '@web/newsfeed/utils/getQueryKey';
import { getPersonasListFromApi } from '@web/common/utils/getPersonasListFromApi';

type Props = {
  pageId: ID;
  articleId: ID;
  seenByCount: number;
};

export const useGetSeenBy = ({ pageId, articleId, seenByCount }: Props) => {
  const { currentUser } = useSession();
  const personaCollection = usePersonaCollection();
  const { newsfeed } = useSlingApi();
  const queryKey = getSeenByQueryKey(pageId, articleId, seenByCount);

  const result = useQuery({
    queryKey,
    queryFn: async () => {
      const { data } = await newsfeed.getSeenBy(pageId, articleId);

      return getPersonasListFromApi(data, personaCollection, currentUser);
    },

    refetchOnMount: false,
  });

  return result;
};
